import { useContext } from "react";
import { MdArrowOutward } from "react-icons/md";
import { AppContext } from "../App";
import { MotionGroup, MotionItem, MotionReveal, MotionText } from "../components/MotionReveal";
import PageHero from "./PageHero";
import CallToAction from "./callToAction";
import civilImage from "../assets/civil engineering (1).jpg";
import buildingImage from "../assets/building construction (1).jpg";
import designImage from "../assets/construction design (1).jpg";
import constructionOne from "../assets/construction1.png";
import constructionTwo from "../assets/construction2.png";
import constructionThree from "../assets/construction3.png";
import roadImage from "../assets/road construction.jpg";
import roofingImage from "../assets/roofing.jpg";
import max1 from "../assets/max1.jpeg";
import max2 from "../assets/max2.jpeg";
import dodoma1 from "../assets/dodoma1.jpeg";
import dodoma2 from "../assets/dodoma2.jpeg";
import dodoma3 from "../assets/dodoma3.jpeg";
import kigamboni from "../assets/kigamboni.jpeg";
import kigamboni1 from "../assets/kigamboni1.jpeg";
import kipawa from "../assets/kipawa.jpeg";
import kipawa1 from "../assets/kipawa1.jpeg";
import kipawa2 from "../assets/kipawa2.jpeg";
import songea1 from "../assets/songea1.png";
import songea2 from "../assets/songea2.png";
import songea3 from "../assets/songea3.png";
import residential from "../assets/residential.jpg";
import civil from "../assets/civil.jpg";
import architecture from "../assets/architectural.jpg";

export function ServiceBadgeIcon({ type }) {
  return (
    <span className={`tgm-service-badge-icon tgm-service-badge-icon-${type}`}>
      <span></span>
      <span></span>
      <span></span>
    </span>
  );
}

export function getServiceTone(index) {
  const tones = ["light", "dark", "accent", "light", "light", "dark", "light", "accent", "dark", "light"];
  return tones[index % tones.length];
}

export const serviceCategories = [
  {
    slug: "residential-construction",
    title: "Residential Construction",
    navTitle: "Residential",
    icon: "home",
    heroImage: residential,
    galleryImages: [buildingImage, kigamboni, kigamboni1],
    summary:
      "Houses, apartments, and residential buildings delivered with careful planning, workmanship, and site supervision.",
    intro:
      "SNJ Tanzania Limited supports residential construction from planning through site execution, helping clients build durable houses, apartments, and related living spaces.",
    subServices: ["Houses", "Apartments", "Residential buildings"],
    highlights: [
      "Ground-up building coordination",
      "Reliable site supervision",
      "Durable residential workmanship",
    ],
  },
  {
    slug: "commercial-construction",
    title: "Commercial Construction",
    navTitle: "Commercial",
    icon: "tower",
    heroImage: constructionOne,
    galleryImages: [constructionOne, max1, max2],
    summary:
      "Offices, retail spaces, and commercial facilities built with coordinated trades and dependable delivery control.",
    intro:
      "The company delivers commercial construction for clients who need functional business spaces, reliable scheduling, and finish quality that supports daily operations.",
    subServices: ["Offices", "Retail spaces", "Commercial facilities"],
    highlights: [
      "Business-focused construction planning",
      "Coordinated trade delivery",
      "Clean commercial finishing",
    ],
  },
  {
    slug: "civil-works",
    title: "Civil Works",
    navTitle: "Civil",
    icon: "path",
    heroImage: civil,
    galleryImages: [civilImage, constructionTwo, roadImage],
    summary:
      "Roads, drainage systems, infrastructure, and related civil engineering scopes delivered with technical oversight.",
    intro:
      "SNJ Tanzania Limited handles civil works with practical planning, quality control, and site coordination for roads, drainage systems, and infrastructure projects.",
    subServices: ["Roads", "Drainage systems", "Infrastructure"],
    highlights: [
      "Road and drainage delivery",
      "Infrastructure site coordination",
      "Civil works quality control",
    ],
  },
  {
    slug: "renovation-refurbishment",
    title: "Renovation & Refurbishment",
    navTitle: "Renovation",
    icon: "maintenance",
    heroImage: kipawa,
    galleryImages: [kipawa, kipawa1, kipawa2],
    summary:
      "Rehabilitation, refurbishment, and renovation works for existing buildings and spaces that need stronger usability.",
    intro:
      "Renovation and refurbishment services help clients improve existing assets with careful coordination, material control, and practical finishing.",
    subServices: ["Rehabilitations", "Refurbishment", "Renovation works"],
    highlights: [
      "Existing-space improvements",
      "Practical rehabilitation planning",
      "Controlled finishing scopes",
    ],
  },
  {
    slug: "project-management-supervision",
    title: "Project Management & Supervision",
    navTitle: "Management",
    icon: "supervision",
    heroImage: constructionThree,
    galleryImages: [constructionThree, designImage, constructionTwo],
    summary:
      "Planning, supervision, coordination, and project control support for construction work with many moving parts.",
    intro:
      "The project management and supervision approach focuses on schedule discipline, communication, field coordination, and timely correction of site issues.",
    subServices: ["Project management", "Site supervision", "Progress control"],
    highlights: [
      "Clear schedules and resource planning",
      "Supervision across work stages",
      "Structured project communication",
    ],
  },
  {
    slug: "public-buildings",
    title: "Public Buildings",
    navTitle: "Public",
    icon: "public",
    heroImage: dodoma1,
    galleryImages: [dodoma1, dodoma2, dodoma3],
    summary:
      "Mosques, schools, churches, institutional buildings, and public-use facilities built with dependable execution.",
    intro:
      "SNJ Tanzania Limited supports public and institutional building projects where function, durability, and stakeholder coordination matter.",
    subServices: ["Mosques", "Schools", "Churches", "Institutional facilities"],
    highlights: [
      "Institutional building delivery",
      "Public-use facility coordination",
      "Durable workmanship standards",
    ],
  },
  {
    slug: "building-maintenance-services",
    title: "Building Maintenance Services",
    navTitle: "Maintenance",
    icon: "blocks",
    heroImage: roofingImage,
    galleryImages: [roofingImage, constructionThree, buildingImage],
    summary:
      "Maintenance services that preserve building condition, improve safety, and keep facilities functional.",
    intro:
      "Building maintenance services help clients protect existing facilities with practical repair, upkeep, and improvement support.",
    subServices: ["Building maintenance", "Repairs", "Facility upkeep"],
    highlights: [
      "Responsive maintenance support",
      "Facility condition improvements",
      "Practical repair coordination",
    ],
  },
  {
    slug: "water-projects",
    title: "Construction of Water Projects",
    navTitle: "Water",
    icon: "water",
    heroImage: songea1,
    galleryImages: [songea1, songea2, songea3],
    summary:
      "Water supply, sanitation, pipe works, and water infrastructure construction delivered with civil works experience.",
    intro:
      "The company profile includes water infrastructure experience, including water supply, sanitation, pipe installation, and rehabilitation projects.",
    subServices: ["Water supply", "Sanitation works", "Pipe installation", "Water infrastructure"],
    highlights: [
      "Civil-water project experience",
      "Pipe and infrastructure works",
      "Responsible site execution",
    ],
  },
  {
    slug: "tower-and-civil-works",
    title: "Tower & Other Civil Works",
    navTitle: "Tower",
    icon: "tower",
    heroImage: constructionTwo,
    galleryImages: [constructionTwo, civilImage, roadImage],
    summary:
      "Construction of tower-related works and other civil construction scopes that require technical coordination.",
    intro:
      "SNJ Tanzania Limited undertakes tower-related works and other civil scopes with the planning and field control needed for dependable delivery.",
    subServices: ["Tower works", "Civil works", "Infrastructure support"],
    highlights: [
      "Technical site planning",
      "Tower and civil coordination",
      "Dependable execution support",
    ],
  },
  {
    slug: "modeling-architecture-structural-design",
    title: "Modelling & Structural Design",
    navTitle: "Design",
    icon: "design",
    heroImage: architecture,
    galleryImages: [designImage, constructionOne, buildingImage],
    summary:
      "Architecture drawings, modelling, and structural design support for buildable construction solutions.",
    intro:
      "The company provides modelling, architecture drawing, and structural design support to help clients move from concept to practical construction decisions.",
    subServices: ["Architecture drawing", "Modelling", "Designing structures"],
    highlights: [
      "Buildable design input",
      "Architecture drawing support",
      "Structural design coordination",
    ],
  },
];

export const homeFeaturedServices = serviceCategories.slice(0, 3);

export const serviceMenuGroups = serviceCategories.map((service) => ({
  title: service.title,
  menuTitle: service.title,
  slug: service.slug,
  items: service.subServices,
}));

export function getServiceBySlug(slug) {
  return serviceCategories.find((service) => service.slug === slug);
}

export default function ServicesContent() {
  const appContext = useContext(AppContext);

  function goToService(slug) {
    appContext.navTo({ item: "services", subItem: slug });
  }

  return (
    <>
      <PageHero
        eyebrow="Services"
        title="A comprehensive range of construction services."
        text="SNJ Tanzania Limited offers residential, commercial, civil, renovation, public building, water project, maintenance, tower, supervision, modelling, and design services."
        image={civilImage}
      />

      <section className="tgm-section tgm-services-page">
        <div className="container">
          <MotionGroup className="tgm-section-head" stagger={0.08}>
            <div>
              <MotionReveal
                as="p"
                className="tgm-section-kicker"
                variant="soft"
              >
                Our Services
              </MotionReveal>
              <MotionText
                as="h2"
                text="Profile-backed construction capabilities."
              />
            </div>
            <MotionReveal as="p" variant="soft" delay={0.12}>
              These service areas follow the company profile and cover building,
              civil, infrastructure, supervision, maintenance, and design needs.
            </MotionReveal>
          </MotionGroup>

          <MotionGroup
            className="tgm-service-badge-grid tgm-service-page-badge-grid"
            stagger={0.06}
          >
            {serviceCategories.map((service, index) => (
              <MotionItem
                as="button"
                variant="card"
                type="button"
                className="tgm-service-badge tgm-service-page-badge"
                data-tone={getServiceTone(index)}
                style={{ "--badge-image": `url(${service.heroImage})` }}
                key={service.slug}
                onClick={() => goToService(service.slug)}
                whileHover={{ y: -9 }}
                whileTap={{ scale: 0.985 }}
              >
                <ServiceBadgeIcon type={service.icon} />
                <MotionText
                  as="strong"
                  text={service.title}
                  stagger={0.035}
                  amount={0.35}
                />
                <MotionReveal
                  as="span"
                  className="tgm-service-badge-summary"
                  variant="soft"
                  delay={0.08}
                >
                  {service.summary}
                </MotionReveal>
                <MotionReveal
                  as="span"
                  className="tgm-service-badge-link"
                  variant="soft"
                  delay={0.14}
                >
                  Learn More <MdArrowOutward />
                </MotionReveal>
              </MotionItem>
            ))}
          </MotionGroup>
        </div>
      </section>

      <CallToAction />
    </>
  );
}
